import api from '@/api';
import Utils from '@/utils';

export const actions = {

    societyContactStore({dispatch}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            data.birth_date = Utils.setDateFormatUSA(data.birth_date);
            let url = data.id ? ('contacts/' + data.id) : 'contacts';
            let method = data.id ? 'PUT' : 'POST';
            api({url: url, data:data, method: method})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyContactGet({dispatch}) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'contacts', method: 'GET'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },
}